import {Injectable} from "@angular/core";
import {Adapter} from "./adapter";

export class vendor {

    public Vendor_ID = null;
    public Vendor_Code = null;
    public Vendor_Name = null;
    public Vendor_LegalName = null;
    public RecoGL_ID = null;
    public Vendor_Status = null;
    public Reason_ID = null;
    public Vendor_StatusReason = null;
    public TemplateId = null;
    public Active = null;
    public VendorReason_Desc = null;
    public Vendor_Address1 = null;
    public Vendor_Address2 = null;
    public Vendor_Address3 = null;
    public State_ID = null;
    public City_ID = null;
    public Vendor_Mobile = null;
    public Vendor_EmailID = null;
    public Vendor_GSTNo = null;
    public Vendor_DLNo_1 = null;
    public Vendor_Balance = null;
    public State_Desc = null;
    public City_Desc = null;
    public VendorClassification_ID = null;
    public VendorClassification_Code = null;
    public VendorClassification_Name = null;
    public Address_Type = [];
    Stockiest_ID: any;

    constructor(public initVal: Partial<vendor>) {
        Object.assign(this, initVal);
    }
}

@Injectable()
export class vendorAdapter implements Adapter<vendor> {
    adapt(item: any): vendor {
        return new vendor(item);
    }
}